<template>
    
    
<footer class="m-5 p-4 bg-white rounded-lg shadow md:flex md:items-center md:justify-between md:p-6 dark:bg-gray-800">
    <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2022 <a href="#" class="hover:underline">JerryFriends™</a>. All Rights Reserved. v025
    </span>
    <ul class="flex flex-wrap items-center mt-3 text-sm text-gray-500 dark:text-gray-400 sm:mt-0">
        <li>
            <router-link to="/about" class="mr-4 hover:underline md:mr-6 ">關於傑瑞團隊</router-link>
        </li>
        <li>
            <router-link to="/priv" class="mr-4 hover:underline md:mr-6">隱私政策</router-link>
        </li>
        <li>
            <a href="mailto: findjerryfriends@gmail.com" class="hover:underline">聯繫我們</a>
        </li>
    </ul>
</footer>


</template>